import { useState, useEffect } from 'react';
import { useReduxStore } from '../../../hooks/useReduxStore';
import { 
  GetAllUsersAction,
  GetUserByIdAction,
  CreateUserAction,
  UpdateUserAction,
  DeleteUserAction,
  BlockUserAction,
  UnblockUserAction,
} from '../../../store/Actions/adminActions';
import { useNavigate } from 'react-router-dom';

const useUserManagement = () => {
  const { getState, dispatch } = useReduxStore();
  const navigate=useNavigate()
  // Get data from store
  const { 
    users, 
    totalUsers, 
    currentPage, 
    totalPages, 
    filters, 
    loading, 
    isError, 
    errorMessage 
  } = getState("ADMIN_USER_MANAGEMENT");


  // Local state for filters
  const [localFilters, setLocalFilters] = useState({
    search: '',
    planId: '',
    status: '',
    join_date: '',
    page: 1,
    limit: 10,
  });

  // Fetch users when component mounts or filters change
  useEffect(() => {
    let {search, planId, status, join_date, page, limit} = localFilters;
    let params = {
      page: page || 1,
      limit: limit || 10
    }
    
    if(search?.length) params.search = search;
    if(planId?.length) params.planId = planId;
    if(status?.length) params.status = status;
    if(join_date?.length) params.join_date = join_date;
  
    console.log("Fetching users with params:", params);
    dispatch(GetAllUsersAction(params));
  }, [localFilters, ]);

  // Set filters function
  const setFilters = (newFilters) => {
    setLocalFilters(prev => ({
      ...prev,
      ...newFilters,
      page: 1, // Reset to first page when filters change
    }));
  };

  // Set current page function
  const setCurrentPage = (page) => {
    setLocalFilters(prev => ({
      ...prev,
      page,
    }));
  };

  // Search users function
  const searchUsers = (searchTerm) => {
    setFilters({ search: searchTerm });
  };

  // Clear filters function
  const clearFilters = () => {
    setLocalFilters({
      search: '',
      planId: '',
      status: '',
      join_date: '',
      page: 1,
      limit: 10,
    });
  };

  // View user function
  const viewUser = (userId) => {
    // Navigate to user detail page
    navigate("/Admin/Dashboard/Users/Detail",{state:{userId}})
  };

  // Edit user function
  const editUser = (userId) => {
    // You can add navigation logic here or open an edit modal
    console.log('Edit user:', userId);
  };

  // Delete user function
  const deleteUser = (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      dispatch(DeleteUserAction(userId));
    }
  };

  // Block user function
  const blockUser = (userId) => {
    if (window.confirm('Are you sure you want to block this user?')) {
      dispatch(BlockUserAction(userId));
    }
  };

  // Unblock user function
  const unblockUser = (userId) => {
    if (window.confirm('Are you sure you want to unblock this user?')) {
      dispatch(UnblockUserAction(userId));
    }
  };

  // Create user function
  const createUser = (userData) => {
    dispatch(CreateUserAction(userData));
  };

  // Update user function
  const updateUser = (userId, userData) => {
    dispatch(UpdateUserAction({ userId, userData }));
  };

  return {
    users,
    totalUsers,
    currentPage,
    totalPages,
    filters: localFilters,
    loading,
    isError,
    errorMessage,
    setFilters,
    setCurrentPage,
    searchUsers,
    clearFilters,
    viewUser,
    editUser,
    deleteUser,
    blockUser,
    unblockUser,
    createUser,
    updateUser,
  };
};

export default useUserManagement;
